import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { formatMoneyBR } from "helpers/formatMoney";
import type { IFinanceiroResumoResponse } from "interfaces/loja/financeiro";
import { FINANCEIRO_ACCENT } from "./financeiro-lancamentos.theme";

function StatMini({
  label,
  value,
  accent,
  valueColor,
}: {
  label: string;
  value: string | number;
  accent?: boolean;
  valueColor?: string;
}) {
  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        border: "1px solid",
        borderColor: accent ? "rgba(249, 96, 48, 0.3)" : "grey.200",
        bgcolor: accent ? "rgba(249, 96, 48, 0.04)" : "background.paper",
        height: "100%",
      }}
    >
      <Typography
        variant="h4"
        fontWeight="bold"
        color={valueColor ?? (accent ? FINANCEIRO_ACCENT : "text.primary")}
      >
        {value}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
    </Box>
  );
}

type Props = {
  resumo: IFinanceiroResumoResponse | null;
  totalLancamentos: number;
  loading?: boolean;
};

export default function LancamentosVendasResumoCards({
  resumo,
  totalLancamentos,
}: Props) {
  const saldo = resumo?.saldo ?? 0;

  return (
    <Grid container spacing={2} mb={3}>
      <Grid item xs={6} sm={3}>
        <StatMini label="Lançamentos no filtro" value={totalLancamentos} accent />
      </Grid>
      <Grid item xs={6} sm={3}>
        <StatMini label="Total receitas" value={formatMoneyBR(resumo?.totalReceitas ?? 0)} />
      </Grid>
      <Grid item xs={6} sm={3}>
        <StatMini label="Total despesas" value={formatMoneyBR(resumo?.totalDespesas ?? 0)} />
      </Grid>
      <Grid item xs={6} sm={3}>
        <StatMini
          label="Saldo do período"
          value={formatMoneyBR(saldo)}
          valueColor={saldo < 0 ? "error.main" : saldo > 0 ? "success.main" : "text.primary"}
        />
      </Grid>
    </Grid>
  );
}
